import React from 'react';
import { skillGroups } from '../data/skills';
import { SectionHeading } from './ui/SectionHeading';
import { Tag } from './ui/Tag';
import { Reveal } from '../lib/motion';

export default function Skills() {
  return (
    <section id="skills" style={{ padding: 'var(--section-pad-y) clamp(20px,5vw,56px)' }}>
      <div style={{ maxWidth: 'var(--container-wide)', margin: '0 auto' }}>
        <Reveal><SectionHeading index="04" eyebrow="Competências" title="O arsenal técnico" /></Reveal>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 18, marginTop: 56 }}>
          {skillGroups.map((cat, i) => (
            <Reveal key={cat.title} delay={i * 70}>
              <div style={{ padding: '24px', borderRadius: 'var(--radius-lg)', background: 'var(--bg-surface)', border: '1px solid var(--border-subtle)', height: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                  <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-muted)' }}>{String(i + 1).padStart(2, '0')}</span>
                  <h3 style={{ fontSize: 17, margin: 0 }}>{cat.title}</h3>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {cat.items.map((s) => <Tag key={s} size="sm" variant={i === 0 ? 'solid' : 'outline'}>{s}</Tag>)}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
